import { Component, OnInit } from '@angular/core';
import { UmsService } from '../ums.service';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { MatTreeNestedDataSource } from '@angular/material/tree';
import { HttpErrorResponse } from '@angular/common/http';
import { ModalpopService } from '../modalpop.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { SlmDialogBoxComponent } from '../slm-dialog-box/slm-dialog-box.component';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-slm',
  templateUrl: './slm.component.html',
  styleUrls: ['./slm.component.scss']
})
export class SlmComponent implements OnInit {

  dialogRef: MatDialogRef<any>;
   slmForm: FormGroup;
   sessionList: any;
   SessionFilterList: any;
   SnId: any;
   StrId: any;
   EsId: any;
   CdCode: any;
   collegeList: any;
   filteredCollegeList: any;
   UserCollege: any;
   userPermission: any;
   utp: any;
   sessCreate = true;
   selected: any;
   selectCollege: any;
   collegeId: any;
   collegecourseList: any;
   CourseList: any;
   filteredListCourse: any;
   examList: any;
   filteredListExam: any;
   disableCollege = true;
   disableCourse = true;
   disableExam = true;
   disableBranch = true;
   disableSubject = true;
   disableMedium = true;
   disableSlmStats = false;
   strId: any;
   filterlist: { id: string; name: string; }[];
   filteredListBranch: any;
   selecttype = true;
   Branch = false;
   BranchList: any;
   emid: any;
   EmId: any;
   courseMediumList: any;
   filteredCourseMediumList: any;
   examSubList: any = [];
   filteredListExamSub: [];
   slmList: any;
   submitpayload: any;
   totalStudents: any;
   totalSlmSent: any;
   totalSlmPending: any;
   convertedDate: any;

   //dropdown values
   sessionId: any;
   clgId: any;
   courseId: any;
   examId: any;
   branchId: any;
   subjectId: any;
   mediumId: any;
   mediumArr: Array<String> = []
   dropdownArr: Array<string | number | Array<any>> = []
   
  

  constructor(
    public umsService: UmsService,
    private fb: FormBuilder,
    private spinner:NgxSpinnerService,
    private modalPopupService: ModalpopService,
    private dialog: MatDialog,
    private datePipe: DatePipe
  ) { }

  ngOnInit(): void {

    this.slmForm = this.fb.group({
      Session: new FormControl ('', [Validators.required]),
      college: new FormControl ('', [Validators.required]),
      course: new FormControl ('', [Validators.required]),
      exam: new FormControl ('', [Validators.required]),
      strId: new FormControl ('', [Validators.required]),
      Subject: new FormControl ('', [Validators.required]),
      CoMediums: new FormControl ('', [Validators.required]),
      });


    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
    this.utp = sessionStorage.getItem('usertypeee');
    if(this.utp !== 'Super Admin' && this.utp !== 'Admin'){
      // this.isSuperAdmin= false;
      this.userPermission.forEach(element => {
      if(element.PageName == 'Course Intake Mapping' && element.PCreate == false)
      {
          this.sessCreate = false;  
      }
    
    });
  }

    let id = ''
    this.fetchSession(id);
    // this.fetchCollege();
   // this.fetchMedium(); commented
   // this.getSlmList();
   //this.fetchCourse(); commented
 
  }



  // session dropdown
  fetchSession(id) {
    const payload = {};
    payload['SnDefault'] = id;
    payload['SnNo'] = id; 
    this.umsService.getSession(payload).subscribe(res => {
      this.sessionList = [];
      if (res.status) {
        res.data.forEach(element => {
          if (element.SnStatus == 'O') {
            this.sessionList.push(element);
          }
        });
        this.SessionFilterList = this.sessionList.slice();
      }
    })
  }

  getSnId(e){  
    this.collegecourseList = [];
    this.filteredListCourse = [];
    this.collegeList = [];
    this.filteredCollegeList = [];
    this.examList = [];
    this.filteredListExam = [];
    this.BranchList = [];
    this.filteredListBranch = [];
    this.examSubList = [];
    this.filteredListExamSub = [];
    this.courseMediumList = [];
    this.filteredCourseMediumList = [];
    this.slmForm.controls['course'].setValue('');
    this.slmForm.controls['college'].setValue('');
    this.slmForm.controls['exam'].setValue('');
    this.slmForm.controls['strId'].setValue('');
    this.slmForm.controls['Subject'].setValue('');
    this.slmForm.controls['CoMediums'].setValue('');

    this.SnId = e;
    this.sessionId = e;
    const sessionPosition = 0
    this.dropdownArr.splice(sessionPosition, 1, this.sessionId);
    //this.dropdownArr.push(this.sessionId);
    this.disableCollege = false;
    this.fetchCourse();
  }

  // college dropdown
  fetchCollege(CoCode) {
    this.collegeList = [];
    this.filteredCollegeList = [];
    this.examList = [];
    this.filteredListExam = [];
    this.BranchList = [];
    this.filteredListBranch = [];
    this.examSubList = [];
    this.filteredListExamSub = [];
    this.courseMediumList = [];
    this.filteredCourseMediumList = [];
    this.slmForm.controls['college'].setValue('');
    this.slmForm.controls['exam'].setValue('');
    this.slmForm.controls['strId'].setValue('');
    this.slmForm.controls['Subject'].setValue('');
    this.slmForm.controls['CoMediums'].setValue('');
    this.spinner.show();
    this.courseId = CoCode;
    const coursePosition = 1
    this.dropdownArr.splice(coursePosition, 1, this.courseId);
    //this.dropdownArr.push(this.courseId);
    if(this.userPermission[0].CgUi == 'C'){
      this.UserCollege= this.userPermission[0].CgId;
    }
    else{
      this.UserCollege = ''
    }
    const payload = {};
    payload['CoCode'] = CoCode;

    this.umsService.fetchstucourseClgMap(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        this.collegeList = res.data;
        this.filteredCollegeList = this.collegeList.slice();
      //  this.SessionCoClg.controls["college"].setValue(''); removed as of now - mehul
      } else {
        this.spinner.hide();
      }
    });
    this.getList(this.courseId);

  }

    // oneClgClick(e,search) {
    //  // this.clgId = e;
    //   this.dropdownArr.push(this.clgId);
    //   this.spinner.show()
    //   this.selected = e;
    //   this.selectCollege = e;
    //   let payload = {};
    //   payload['SearchString'] = search
    //   this.collegeId = e;
    //   this.umsService.getCourse(payload).subscribe((allres) => {
    //     this.spinner.hide()
    //     if (allres.data.length > 0) {
    //       let allcourseList = [];
    //       allcourseList = allres.data;
    //       const collegeFetchPayload = {};
    //       collegeFetchPayload['CgCode'] = e;
    //       collegeFetchPayload['CoCode'] = '';
    //       this.umsService.getCollegeCourse(collegeFetchPayload).subscribe((res) => {
    //         this.collegecourseList = res.data;
    //         this.filteredListCourse = this.collegecourseList.slice();
    //         this.spinner.hide();
    //         this.disableCourse = false;
    //       });
    //     } else {
    //       this.spinner.hide();
    //     }
    //   });
    
    // }
    
    getClgID(CgCode){
      // this.examList = [];
      // this.filteredListExam = [];
      this.BranchList = [];
      this.filteredListBranch = [];
      this.examSubList = [];
      this.filteredListExamSub = [];
      this.courseMediumList = [];
      this.filteredCourseMediumList = [];
      this.slmForm.controls['exam'].setValue('');
      this.slmForm.controls['strId'].setValue('');
      this.slmForm.controls['Subject'].setValue('');
      this.slmForm.controls['CoMediums'].setValue('');
      this.clgId = CgCode;
      const collegePosition = 2
      this.dropdownArr.splice(collegePosition, 1, this.clgId);
     // this.dropdownArr.push(this.clgId);
    }

    // course dropdown
    fetchCourse() {
      if (this.userPermission[0].CgUi == 'C') {
        this.UserCollege = this.userPermission[0].CgId;
      }
      else {
        this.UserCollege = ''
      }
      const payload = {};
      this.spinner.show();
      // payload['LoginId'] = 0;
      // payload['CgCode'] = this.UserCollege
      this.umsService.getCourse(payload).subscribe(res => {
        if (res.status) {
          this.spinner.hide();
          this.collegecourseList = res.data;
          this.filteredListCourse = this.collegecourseList.slice();
          
        }
        else {
          this.spinner.hide();
        }
      },);
    }

    getList(e) {
      this.BranchList = [];
      this.filteredListBranch = [];
      this.examSubList = [];
      this.filteredListExamSub = [];
       // this.dropdownArr.push(this.courseId);
        this.spinner.show();
        this.strId = '';
      //  this.fetchList();
      //  this.umsService.courseData = e;
        const payload = {};
        this.filterlist = [];
        this.examList = [];
        this.filteredListExam = [];
        this.filteredListBranch = [];
        payload['EmCoCode'] = e;
        this.selecttype = true;
        this.umsService.getExam(payload).subscribe(res => {
          if (res.status) {
            this.examList = res.data;
            this.spinner.hide();
            this.filteredListExam = this.examList.slice();
            this.disableExam = false;
          }
          else {
            this.spinner.hide();
          }
        }, (ERROR: HttpErrorResponse) => {
          this.spinner.hide();
          let data = {}
          data['message'] = ERROR.error.message
          data['title'] = 'Alert'
          data['icon'] = 'fas fa-close'
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
          this.ngOnInit();
          // this.umsService.openSnackbar(ERROR.error.message);
    
        });
      }

      get(e) {
        
        this.BranchList = [];
        this.filteredListBranch = [];
        this.examSubList = [];
        this.filteredListExamSub = [];
        this.courseMediumList = [];
        this.filteredCourseMediumList = [];
        this.slmForm.controls['strId'].setValue('');
        this.slmForm.controls['Subject'].setValue('');
        this.slmForm.controls['CoMediums'].setValue('');
        this.examId = e.EmId;
        const examPosition = 3
        this.dropdownArr.splice(examPosition, 1, this.examId);
       // this.dropdownArr.push(this.examId);
        this.spinner.show();
        this.selecttype = false;
        this.filterlist = []
        this.filteredListBranch = [];
        this.umsService.examData = e;
        this.emid = e.EmId;
        this.strId = 0;
        if (e.EmStreams == "Y") {
          this.filterlist = [];
          this.spinner.hide();
          this.Branch = true;
          this.disableBranch = false;
          this.fetchBranch(e.EmId);
        }
    
        else {
          this.spinner.hide();
          this.branchId = 0;
          const branchPosition1 = 4
          this.dropdownArr.splice(branchPosition1, 1, this.branchId);
          //this.dropdownArr.push(this.branchId);
          this.Branch = false;
          this.disableSubject = false;
          this.filterlist = [];
          const payload = {};
          payload['EsEmId'] = e.EmId;
          payload['EsStrId'] = 0;
          this.umsService.getExamSubMapFetch(payload).subscribe(res => {
            this.spinner.hide();

          res.data.children.forEach(element => {
            if (element.EsType == 'S') {
              this.examSubList.push(element)
            }
            else if (element.EsType == 'G') {
              element.children.forEach(grpSub => {
                this.examSubList.push(grpSub)
              });
            }
            this.filteredListExamSub = this.examSubList.slice();
  
          });
           
          });
        }
      }

      getEsId(e){
        this.courseMediumList = [];
        this.filteredCourseMediumList = [];
        this.slmForm.controls['CoMediums'].setValue('');
        this.subjectId = e;
        const subjectPosition = 5
        this.dropdownArr.splice(subjectPosition, 1, this.subjectId);
     //   this.dropdownArr.push(this.subjectId);
        this.EsId = e;
        this.disableMedium = false;
        this.fetchMedium();
      }

      
      // branch dropdown
      fetchBranch(id) {
        const payload = {};
        payload['EmId'] = id;
        this.umsService.getExamStream(payload).subscribe(res => {
          if (res.status) {
            this.BranchList = res.data;
            this.filteredListBranch = this.BranchList.slice();
          }
        });
      }

      getStrId(e){
        this.examSubList = [];
        this.filteredListExamSub = [];
        this.courseMediumList = [];
        this.filteredCourseMediumList = [];
        this.slmForm.controls['Subject'].setValue('');
        this.slmForm.controls['CoMediums'].setValue('');
        this.spinner.show();
        this.branchId = e;
        const branchPosition2 = 4
        this.dropdownArr.splice(branchPosition2, 1, this.branchId);
      //  this.dropdownArr.push(this.branchId);
        this.StrId = e;
        this.disableSubject = false;
        const payload = {};
        payload['EsEmId'] = this.examId;
        payload['EsStrId'] = this.branchId;
        this.umsService.getExamSubMapFetch(payload).subscribe(res => {
        this.spinner.hide();

        res.data.children.forEach(element => {
          if (element.EsType == 'S') {
            this.examSubList.push(element)
          }
          else if (element.EsType == 'G') {
            element.children.forEach(grpSub => {
              this.examSubList.push(grpSub)
            });
          }
          this.filteredListExamSub = this.examSubList.slice();

        });
         
        });
      }

      // medium dropdown
      fetchMedium() {
        this.spinner.show();
        this.umsService.getCourseMedium().subscribe(res => {
          if (res.status) {
            this.spinner.hide();
            this.courseMediumList = res.data;
            // this.medi = res.data.
            this.filteredCourseMediumList = this.courseMediumList.slice();
            // this.courseForm.controls['CoMediums'].setValue(['E']);
    
          }
        })
      }

      getCdCode(e){
        this.mediumId = e;
        const mediumPosition = 6
        this.dropdownArr.splice(mediumPosition, 1, this.mediumId);
       // this.dropdownArr.push(this.mediumId);
        this.CdCode = e;
        this.disableSlmStats = true;
        this.getSlmData();
         }


      addnewrecord(k){
         const dialogRef = this.dialog.open(SlmDialogBoxComponent, {
              width: '110vh',
              data: {selected: k, key : "New"},
              disableClose: true   
            });
          dialogRef.afterClosed().subscribe(result => {
              
            });  

           
      }

      editData(k){
         const dialogRef = this.dialog.open(SlmDialogBoxComponent, {
            width: '110vh',
            data: { selected: k, key : "Edit"},
            disableClose: true 
          });
          dialogRef.afterClosed().subscribe(result => {
              
          });
      }

      deleteData(k){
       const dialogRef = this.dialog.open(SlmDialogBoxComponent, {
            width: '110vh',
            data: { selected: k, key : "Delete"},
            disableClose: true 
          });
          dialogRef.afterClosed().subscribe(result => {
          
          });
      }

   getSlmData(){
     this.spinner.show();
     this.submitpayload = {}
     this.submitpayload['SnNo'] = this.dropdownArr[0];
     this.submitpayload['CoCode'] = this.dropdownArr[1];
     this.submitpayload['StudyCenter'] = this.dropdownArr[2];
     this.submitpayload['EmId'] = this.dropdownArr[3];
     this.submitpayload['Branch'] = this.dropdownArr[4];
     this.submitpayload['Sub'] = this.dropdownArr[5];
     this.submitpayload['Med'] = this.dropdownArr[6];
     this.umsService.getSlmData(this.submitpayload).subscribe(res => {
      if(res.status){
        this.spinner.hide();
        this.slmList = res.data;
        const entryDate = res.data[0]['EntryDate'];
        this.convertedDate = this.datePipe.transform(entryDate, 'dd-MM-yyyy'); 
        this.totalStudents = res.data[0]['TotalStud'];
        this.totalSlmSent = res.data[0]['TotalSlmSent']; 
        this.totalSlmPending = res.data[0]['TotSlmPending'];
      }
      else{
        this.spinner.hide()
      }
     
    },(ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });

   }

}
